export default __webpack_public_path__ + "static/media/img4.596b6a3f.png";